import { webMcpControllerCall } from '../api/generated/api/webMcp'
import {
  dispatchLightscapeChanged,
  projectIdOfCall,
  WRITE_TOOLS,
} from './lightscapeEvents'

export type WebMcpToolError = { error: string; code?: string; upgradeUrl?: string }
export type WebMcpOutcome = { ok: true; result: unknown } | { ok: false; error: WebMcpToolError }

/** Where the page is, sent as an (untrusted, log-only) hint with each call. */
export const pageContext = () => {
  const route = window.location.pathname
  const projectId = /^\/projects\/([^/]+)/.exec(route)?.[1]
  return { route, projectId }
}

/**
 * Calls one canonical LightScape tool through the authenticated `/webmcp/call` gateway. After a
 * successful write it fires `lightscape:changed`, so the open editor reloads the scene live.
 */
export const callLightscapeTool = async (
  name: string,
  args: Record<string, unknown> = {},
  signal?: AbortSignal,
): Promise<WebMcpOutcome> => {
  const outcome = (await webMcpControllerCall(
    { name, arguments: args, context: pageContext() },
    { signal },
  )) as WebMcpOutcome
  if (outcome.ok && WRITE_TOOLS.has(name)) {
    dispatchLightscapeChanged({ projectId: projectIdOfCall(name, args, outcome.result), tool: name })
  }
  return outcome
}
